<div class="container-fluid h-100 readOnlyForm pl-0 pr-0">

  <!-- Section header start -->
  <div class="headerBackground card p-1 mb-2 tool-header-height">
    <div class="row padding2px">
      <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 sectionHeaderIcon">
        <span>
          <!-- <fa-icon class="fas checklistIcon"   [icon]="faCircle">
          </fa-icon> -->
          <fa-icon class="fas fa-lg autoCursor" title="click for smart checklist" (click)="openSmartChecklist()"
            [icon]="faListOl"></fa-icon>
        </span>
      </div>
      <div class="col col-3 col-md-3 col-lg-3 col-sm-3 col-xs-4">
        <h6 class="headerFontSize cursorArrow">{{ 'menu.checklist' | translate }}</h6>
      </div>
      <div class="col col-6 col-md-6 col-lg-6 col-sm-6 col-xs-6 cursorArrow">
        <p class="titleParagraph">{{'checklist.toolHeaderLine1' | translate}}<br>
          {{'checklist.toolHeaderLine2' | translate}}
        </p>
      </div>
      <div class="col col-2 col-md-2 col-lg-2 col-sm-2 col-xs-2">
        <table class="dropGroupBtn">
          <tr>
            <td rowspan="2">
              <span>
                <a type="button" (click)="openChatGPTassist()">
                  <fa-icon class="fas fa-lg toolLogoYellow" [icon]="faLightbulb" title="intelligent assistant"></fa-icon>
                </a>
              </span>
            </td>
            <td rowspan="2">
              <span>
                <a type="button" class="" data-toggle="modal" data-target="#ytVideoLinkCL">
                  <fa-icon class="fas fa-lg" [icon]="faInfoCircle" title="help"></fa-icon>
                </a>
              </span>
            </td>
            <td rowspan="2">
              <span (click)="checklistName && generateReport('true')">
                <fa-icon class="fas fa-lg cursorPointer" [icon]="faFileExport" title="report"></fa-icon>
              </span>
            </td>
            <td rowspan="2">
              <span class="autoCursor ">
                <fa-icon class="fas fa-lg extraIcon" [icon]="faFileExport" title="report"></fa-icon>
              </span>
            </td>
          </tr>
        </table>
        <!-- <div class="dropGroupBtn marginbottom5px">
          <span>
            <a type="button" class="" data-toggle="modal" data-target="#ytVideoLinkCL">
              <fa-icon class="fas" [icon]="faInfo"></fa-icon>
            </a>
          </span>
        </div>
        <div class="dropGroupBtn marginbottom5px">
          <span (click)="checklistName && goToView();generateReport('')">
            <fa-icon class="fas" [icon]="faFileExport" title="report"></fa-icon>
          </span>
        </div> -->
      </div>
    </div>
  </div>
  <!-- Section header end -->
  <div class="environ-designer tool-body-height">
    <div class="card p-1 mb-2 bg-black h-100">
      <div class="row full-width card p-0 bg-white">
        <div class="row strict h-100">
          <div class="row full-width p-0">
            <div class="col-xs-9 btn-padding pl-0">
              <div class="dropdown" *ngIf="showText != true">
                <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                  type="button" data-toggle="dropdown"
                  [ngClass]="{ dis:modelData.checklists.length<=0 && publicChecklists.length<=0}">
                  <div class="row strict">
                    <div class="col-xs-10 span-on-button ">
                      <span *ngIf="selectedChecklist.checklistName != ''">&nbsp;
                        {{selectedChecklist.checklistName|| 'checklist.chooseChecklistHeading' | translate }}
                      </span>
                      <span *ngIf="selectedChecklist.checklistName == ''">
                        {{ 'checklist.addChecklistHeading' | translate }}
                      </span>
                    </div>
                    <div class="col-xs-1 col-xs-offset-1 pull-right ">
                      <span class="caret"></span>
                    </div>
                  </div>
                </button>
                <ul class="dropdown-menu">
                  <li (click)="chooseChecklist(false,false,cl)" *ngFor="let cl of modelData.checklists">
                    <a>{{cl.checklistName}}</a>
                  </li>
                  <hr *ngIf='modelData.checklists.length>0 && publicChecklists.length>0'
                    class="mt-1 mb-1 border-top-1px-black" />
                  <li (click)="chooseChecklist(false,false,cl)" *ngFor="let cl of publicChecklists">
                    <a>
                      <fa-icon class="fas" [icon]="faLock"></fa-icon> &nbsp;{{cl.checklistName}}
                    </a>
                  </li>
                </ul>
              </div>
              <div *ngIf="showText == true">
                <input type="text" (keyup.enter)="saveChecklist()" id="addchecklistID"
                  [placeholder]="'checklist.checklistNamePlaceholder'|translate" [(ngModel)]="checklistName"
                  class="form-control strict xs-input checklist-inputfield pl-3 pr-3">
              </div>
            </div>
            <div class="col-xs-2 btn-padding pr-0">
              <div class="row strict">
                <div class="col-xs-3 col-xs-offset-1 col-sm-3 col-sm-offset-1">
                  <div>
                    <button type="button" (click)="chooseChecklist(true,true,{})"
                      class="btn btn-default btn-block btn-sm paddingtop3px paddingbottom3px">
                      <fa-icon class="fas icon-black" [icon]="faPlus"></fa-icon>
                    </button>
                  </div>
                </div>
                <div class="col-xs-3 col-xs-offset-1 col-sm-3 col-sm-offset-1">
                  <div>
                    <button type="button" (click)="editChecklist(selectedChecklist.checklistName)"
                      class="btn btn-default btn-block btn-sm paddingtop3px paddingbottom3px"
                      [ngClass]="{ dis:showText == true || new == true || selectedChecklist.checkType =='public'}">
                      <fa-icon class="fas icon-black" [icon]="faEdit"></fa-icon>
                    </button>
                  </div>
                </div>
                <div class="col-xs-3 col-xs-offset-1 col-sm-3 col-sm-offset-1">
                  <div *ngIf="showText != true">
                    <button type="button" data-toggle="modal" data-target="#checklistDeleteConfirmModel"
                      class="btn btn-default btn-block btn-sm paddingtop3px paddingbottom3px">
                      <fa-icon class="fas icon-black" [icon]="faTrash"></fa-icon>
                    </button>
                  </div>
                  <div *ngIf="showText == true">
                    <button type="button" (click)="clear()"
                      class="btn btn-default btn-block btn-sm paddingtop3px paddingbottom3px">
                      <fa-icon class="fas icon-black" [icon]="faTimes"></fa-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row checklist-tool-checklist-section-height pl-0 pr-0">
        <div class="row strict h-100">
          <!-- <div class="col-xs-3 col-md-3 table-bordered card textClrWhite h-100">
            <h4>{{'checklist.navHeader' | translate}}</h4>
            <ol class="listStyleNone pl-2 overflowY">
              <li>1. {{'checklist.navSubHeader1' | translate}}</li>
              <li>2. {{'checklist.navSubHeader2' | translate}}</li>
              <ol class="listStyleNone pl-4">
                <li>a. {{'checklist.navSubHeader2Sub1' | translate}}</li>
                <li>b. {{'checklist.navSubHeader2Sub2' | translate}}</li>
                <li>c. {{'checklist.navSubHeader2Sub3' | translate}}</li>
              </ol>
              <li>3. {{'checklist.navSubHeader3' | translate}}</li>
              <ol class="listStyleNone pl-4">
                <li>a. {{'checklist.navSubHeader3Sub1' | translate}}</li>
                <li>b. {{'checklist.navSubHeader3Sub2' | translate}}</li>
                <li>c. {{'checklist.navSubHeader3Sub3' | translate}}</li>
              </ol>
              <li>4. {{'checklist.navSubHeader4' | translate}}</li>
              <ol class="listStyleNone pl-4">
                <li>a. {{'checklist.navSubHeader4Sub1' | translate}}</li>
                <li>b. {{'checklist.navSubHeader4Sub2' | translate}}</li>
                <li>c. {{'checklist.navSubHeader4Sub3' | translate}}</li>
                <li>d. {{'checklist.navSubHeader4Sub4' | translate}}</li>
                <li>e. {{'checklist.navSubHeader4Sub5' | translate}}</li>
              </ol>
              <li>5. {{'checklist.navSubHeader5' | translate}}</li>
              <ol class="listStyleNone pl-4">
                <li>a. {{'checklist.navSubHeader5Sub1' | translate}}</li>
                <li>b. {{'checklist.navSubHeader5Sub2' | translate}}</li>
                <li>c. {{'checklist.navSubHeader5Sub3' | translate}}</li>
              </ol>
            </ol>
          </div> -->
          <div class="col-xs-12 col-md-12 card h-100 pl-2">
            <div id="checklistQuillCSS">
              <quill-editor (onEditorChanged)="editorChanged($event)" [(ngModel)]="checklistEditorContent">
                <div quill-editor-toolbar>
                  <span class="ql-formats">
                    <select class="ql-header"></select>
                    <button class="ql-bold" [title]="'Bold'"></button>
                    <button class="ql-italic" [title]="'Italic'"></button>
                    <button class="ql-underline" [title]="'Underline'"></button>
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                    <button class="ql-image" [title]="'Image'"></button>
                    <button class="ql-code" [title]="'Code'"></button>
                  </span>
                </div>
              </quill-editor>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- Section footer start -->
  <div class="headerBackground card p-1 mt-2 tool-footer-height">
    <div class='row pb-0 pt-0'>
      <div id="checklistsperTip" class="carousel slide" data-ride="carousel" data-interval="false">
        <!-- Wrapper for slides -->
        <div class="carousel-inner text-color-yellow">
          <div class="row item active text-color-yellow">
            <div class="col-xs-12 align_center carousel-tip-align">
              Tip #1 : {{'checklist.tip1' | translate}}
            </div>
          </div>

          <div class="row item">
            <div class="col-xs-12 align_center carousel-tip-align">
              Tip #2 : {{'checklist.tip2' | translate}}
            </div>
          </div>

          <div class="row item">
            <div class="col-xs-12 align_center carousel-tip-align">
              Tip #3 : {{'checklist.tip3' | translate}}
            </div>
          </div>
        </div>
        <!-- Left and right controls -->
        <a class="left carousel-control carousel-tip-align display-flex" data-target="#checklistsperTip"
          data-slide="prev">
          <span>
            <fa-icon class="fas" [icon]="faChevronLeft"></fa-icon>
          </span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="right carousel-control carousel-tip-align display-flex" data-target="#checklistsperTip"
          data-slide="next">
          <span>
            <fa-icon class="fas" [icon]="faChevronRight"></fa-icon>
          </span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
  </div>

  <!-- Section footer end -->
  <div class="modal fade" id="checklistDuplicateModel" data-backdrop="">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body">
            <div class="row pb-0">
              <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
              <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>
              <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div class="form-element text-align-center">
                  <label class="form-label marginbottom6px text-align-center">{{errorMessage}}</label>
                </div>
              </div>
            </div>
          </div>
          <!-- Modal footer -->
          <div class="modal-footer text-align-center">
            <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal">
              {{ 'ok' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="checklistDeleteConfirmModel" data-backdrop="">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body">
            <div class="row pb-0">
              <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
              <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>
              <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div class="form-element text-align-center">
                  <label class="form-label marginbottom6px">{{'checklist.deletechecklist' | translate}}</label>
                </div>
              </div>
            </div>
          </div>
          <!-- Modal footer -->
          <div class="modal-footer text-align-center">
            <button type="button" class="btn btn-secondary modalActionBtn marginright10per"
              (click)="deleteChecklist(selectedChecklist)" data-dismiss="modal">{{'yes' | translate}}</button>
            <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal">{{'no' |
              translate}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Youtube video Modal -->
  <div class="modal fade bd-example-modal-lg" id="ytVideoLinkCL" tabindex="-1" role="dialog"
    aria-labelledby="ytVideoLinkCL" aria-hidden="true">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content ytVideoLink">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" (click)="terminateVideo()"
              aria-hidden="true">&times;</button>
            <h4 class="modal-title cursorArrow" id="myModalLabel">{{'youtubeVideoTitle.checklist' | translate}}</h4>
          </div>
          <!-- Modal body -->
          <div class="modal-body">
            <iframe width="100%" height="100%" class="youtubeVideo" id="ClVideoLink" frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>